var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnooze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 75C31.6359 75 22.4156 71.1808 15.6174 64.3826C8.81919 57.5844 5 48.3641 5 38.75C5 24.0625 13.4375 10.8937 26.5016 5.20781C26.962 5.00715 27.4722 4.94982 27.9657 5.04329C28.4591 5.13676 28.913 5.3767 29.2682 5.73184C29.6233 6.08699 29.8632 6.54087 29.9567 7.03435C30.0502 7.52782 29.9929 8.03801 29.7922 8.49844C28.2922 11.9422 27.5 16.3531 27.5 21.25C27.5 38.4812 41.5187 52.5 58.75 52.5C63.6469 52.5 68.0578 51.7078 71.5016 50.2078C71.962 50.0071 72.4722 49.9498 72.9657 50.0433C73.4591 50.1368 73.913 50.3767 74.2682 50.7318C74.6233 51.087 74.8632 51.5409 74.9567 52.0343C75.0502 52.5278 74.9929 53.038 74.7922 53.4984C69.1063 66.5625 55.9375 75 41.25 75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5656 36.1196L41.6822 34.1351L39.982 19.3042L42.0986 19.5123L35.0307 26.2199L32.4534 23.5041L41.6451 14.781L43.512 16.7482L45.2809 31.5469L43.2286 31.4763L50.9232 24.174L53.4013 26.7852L43.5656 36.1196Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1206 33.4259L57.2747 29.7604L61.253 7.72461L64.2027 8.93979L51.1484 15.5135L48.6226 10.4975L65.5996 1.94852L67.4292 5.58185L63.5636 27.6012L60.6467 26.6114L74.8585 19.4548L77.2872 24.2778L59.1206 33.4259Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnooze);
export default __webpack_public_path__ + "static/media/snooze.28f3aa1233410b218bb0b10535f67d68.svg";
export { ForwardRef as ReactComponent };